/**
 * @generated SignedSource<<1219389f96edf97a7635e76060574b15>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type FileType = "DOC" | "DOCX" | "PDF" | "PPT" | "PPTX" | "XLS" | "XLSX";
export type FileUploadAreaWorkspaceMutation$variables = {
  name?: string | null;
  type: FileType;
  workspaceId: string;
};
export type FileUploadAreaWorkspaceMutation$data = {
  readonly workspace: {
    readonly generateFileUploadLink: {
      readonly id: string;
      readonly url: string;
    };
  };
};
export type FileUploadAreaWorkspaceMutation = {
  response: FileUploadAreaWorkspaceMutation$data;
  variables: FileUploadAreaWorkspaceMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "name"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "type"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "workspaceId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "workspaceId"
      }
    ],
    "concreteType": "WorkspaceMutation",
    "kind": "LinkedField",
    "name": "workspace",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "name",
            "variableName": "name"
          },
          {
            "kind": "Variable",
            "name": "type",
            "variableName": "type"
          }
        ],
        "concreteType": "UploadLink",
        "kind": "LinkedField",
        "name": "generateFileUploadLink",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "url",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FileUploadAreaWorkspaceMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FileUploadAreaWorkspaceMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b14b507c51abdc6542c34a37d0e40e02",
    "id": null,
    "metadata": {},
    "name": "FileUploadAreaWorkspaceMutation",
    "operationKind": "mutation",
    "text": "mutation FileUploadAreaWorkspaceMutation(\n  $name: String\n  $type: FileType!\n  $workspaceId: ID!\n) {\n  workspace(id: $workspaceId) {\n    generateFileUploadLink(type: $type, name: $name) {\n      id\n      url\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "60c46d168abd1e55a4ac2c3af3c49036";

export default node;
